module.exports = __webpack_public_path__ + "static/img/s5.d309657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/s5.png
// module id = 3MxY
// module chunks = 1